<template>
  <div class="button" @click="btnClick" :class="computedClass">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "CellComponent",
  props: {
    type: {
      // text:纯文字，primary:文字白色其余地方主题侧 border:边框字体主题色其余透明
      type: String,
      default: "text",
    },
    active: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    computedClass() {
      return {
        primary: this.type === "primary",
        lock: !this.active,
        border: this.type === "border",
      };
    },
  },
  methods: {
    btnClick() {
      if (this.active) {
        this.$emit("click");
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "../../assets/style/theme.less";

.button {
  font-size: 16px;
  color: @theme-color;
  padding: 0;
  border: 0;
  border-radius: 4px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  align-content: center;
  white-space: nowrap;
  cursor: pointer;
  &.primary {
    background: @theme-color;
    color: white;
    &:active,
    &:hover {
      background: lighten(@theme-color, 10%);
      color: white;
    }
  }
  &.border {
    border: 2px solid @theme-color;
    &:active,
    &:hover {
      border-color: lighten(@theme-color, 10%);
      background: rgba(0, 0, 0, 0.05);
      color: @theme-color;
    }
  }
  &:active,
  &:hover {
    color: darken(@theme-color, 10%);
  }
  &.lock {
    color: @border-color;
    &.primary {
      background: @border-color;
      color: white;
    }
    &.border {
      border-color: @border-color;
      color: @border-color;
    }
  }
}
</style>
